/* 
    Find the index of a sorted array that an item should be added to keep array sorted. 
    [...arr.slice(0, x), val, ...arr.slice(x)] is sorted.
    prioritize left is used to position equal values to the right of the index.
*/
function bisectRegion(targ, arr, getVal, prioritizeLeft = true) {
  const a = arr || [];
  let l = 0;
  let r = arr.length - 1;

  while (l <= r) {
    const i = Math.floor((l + r) / 2);
    const x = getVal(a[i]);
    const isEq = x === targ;
    const lookLeft = targ < x || (isEq && prioritizeLeft);
    const lookRight = targ > x || (isEq && !prioritizeLeft);
    if (l === r) {
      if (targ === x) return prioritizeLeft ? i : i + 1;
      if (targ < x) return i;
      if (targ > x) return i + 1;
    }
    if (lookLeft) r = i;
    if (lookRight) l = i + 1;
  }
  return null;
}

export default bisectRegion;
